import { useLocation } from 'react-router-dom';
import { LogOut } from 'lucide-react';
import { useAuth } from '@/hooks/use-auth';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';

/** Map route paths to human-readable section titles. */
function getSectionTitle(pathname: string): string {
  if (pathname === '/') return 'Dashboard';
  if (pathname.startsWith('/llm-config')) return 'LLM Configuration';
  if (pathname.startsWith('/whatsapp-config')) return 'WhatsApp Configuration';
  if (pathname.startsWith('/documents')) return 'Documents';
  if (pathname.startsWith('/messages')) return 'Messages';
  return 'Dashboard';
}

export default function Header() {
  const { pathname } = useLocation();
  const { displayName, role, logout } = useAuth();

  const title = getSectionTitle(pathname);
  const roleLabel = role === 'Admin_User' ? 'Admin' : 'Tenant';

  return (
    <header className="flex h-14 items-center justify-between border-b bg-card px-4 md:px-6">
      {/* Left: page title (offset on mobile to avoid hamburger overlap) */}
      <h1 className="pl-12 md:pl-0 text-lg font-semibold truncate">{title}</h1>

      {/* Right: user badge + logout */}
      <div className="flex items-center gap-2">
        <span className="text-sm text-muted-foreground hidden sm:inline">
          {displayName}
        </span>
        <Badge variant={role === 'Admin_User' ? 'default' : 'secondary'}>
          {roleLabel}
        </Badge>
        <Button variant="ghost" size="icon" onClick={logout} aria-label="Logout">
          <LogOut className="h-4 w-4" />
        </Button>
      </div>
    </header>
  );
}
